import axiosInstance from "@/config/axios";

export const getRoles = async () => {
	// ສິດການນຳໃຊ້: ດຶງມາ Filter ແລະ ປ້ອນໃສ່ Admin, SOE
	const response = await axiosInstance.get("/master/roles");
	return response.data;
};

export const getStatus = async () => {
	// ສະຖານະ: ດຶງມາ Filter ແລະ ປ້ອນໃສ່ Admin, SOE

	const response = await axiosInstance.get("/master/status");
	return response.data;
};

export const getProvinces = async () => {
	const response = await axiosInstance.get("/master/provinces");
	return response.data;
};

export const getDistrict = async (provinceId: string) => {
	const response = await axiosInstance.get(`/master/${provinceId}/districts`);
	return response.data;
};

export const getSectors = async () => {
	// ຂະແໜງການ
	const response = await axiosInstance.get("/master/sectors");
	return response.data;
};

export const getCoreSectors = async () => {
	// ຂະແໜງການຍ່ອຍ
	const response = await axiosInstance.get("/master/core-sectors");
	return response.data;
};

export const getMinistries = async () => {
	// ກະຊວງ
	const response = await axiosInstance.get("/master/ministries");
	return response.data;
};

export const getDepartments = async () => {
	// ພະແນກ
	const response = await axiosInstance.get("/master/departments");
	return response.data;
};

export const getEconomicRegions = async () => {
	// ຂົງເຂດທຸລະກິດ
	const response = await axiosInstance.get("/master/economic-regions");
	return response.data;
};

export const getLawTypes = async () => {
	// ປະເພດກົດໝາຍ ແລະ ນິຕິກຳ
	const response = await axiosInstance.get("/master/law-types");
	return response.data;
};

export const getInfoTypes = async () => {
	// ປະເພດຂ່າວສານ
	const response = await axiosInstance.get("/master/info-types");
	return response.data;
};

export const getTenureLength = async () => {
	// ໄລຍະຍປະຈຳການ
	const response = await axiosInstance.get("/master/tenure-length");
	return response.data;
};

export const getBoardPositions = async () => {
	const response = await axiosInstance.get("/master/board-positions");
	return response.data;
};

export const getTenureStatus = async () => {
	const response = await axiosInstance.get("/master/tenure-status");
	return response.data;
};

export const getBoardDirectorTypes = async () => {
	const response = await axiosInstance.get("/master/board-director-types");
	return response.data;
};


export const getLandStatus = async () => {
	const response = await axiosInstance.get("/master/land-status");
	return response.data;
};

export const getLandFundTypes = async () => {
	const response = await axiosInstance.get("/master/land-fund-types");
	return response.data;
};